export default __webpack_public_path__ + "static/media/08.42a8c764.jpg";